import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './component/layout/auth/auth.component';
import { AdminPanelComponent } from './component/layout/admin-panel/admin-panel.component';
import { AuthGuard } from './core/auth/auth.guard';
import { APP_ROUTES } from './core/constants/app-routes';
import { LoginGuard } from './core/auth/login.guard';
import { AdminGuard } from './core/auth/admin.guard';
import { UnsavedChangesGuard } from './core/guards/unsaved-changes.guard';
import { BlankComponent } from './component/layout/blank/blank.component';

const routes: Routes = [
  {
    path: APP_ROUTES.auth.selectOrganization,
    component: AuthComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/select-organization/select-organization.component').then((m) => m.SelectOrganizationComponent),
      },
    ]
  },
  {
    path: APP_ROUTES.download.base,
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/download/download.component').then((m) => m.DownloadComponent),
      },
    ],
  },
  {
    path: 'download-laasy',
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/download/download.component').then((m) => m.DownloadComponent),
      },
    ],
  },
  {
    path: 'download-wow',
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/download/download.component').then((m) => m.DownloadComponent),
      },
    ],
  },
  {
    path: 'download-kapital',
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/download/download.component').then((m) => m.DownloadComponent),
      },
    ],
  },
  {
    path: 'download-unifywell',
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/download/download.component').then((m) => m.DownloadComponent),
      },
    ],
  },
  {
    path: APP_ROUTES['opt-me-out'].base,
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/opt-me-out/opt-me-out.component').then((m) => m.OptMeOutComponent),
      },
    ],
  },
  {
    path: "opt-me-out-laasy",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/opt-me-out/opt-me-out.component').then((m) => m.OptMeOutComponent),
      },
    ],
  },
  {
    path: "opt-me-out-wow",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/opt-me-out/opt-me-out.component').then((m) => m.OptMeOutComponent),
      },
    ],
  },
  {
    path: "opt-me-out-kapital",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/opt-me-out/opt-me-out.component').then((m) => m.OptMeOutComponent),
      },
    ],
  },
  {
    path: "opt-me-out-unifywell",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/opt-me-out/opt-me-out.component').then((m) => m.OptMeOutComponent),
      },
    ],
  },
  {
    path: APP_ROUTES.learnMore.base,
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/learn-more/learn-more.component').then((m) => m.LearnMoreComponent),
      },
    ],
  },
  {
    path: APP_ROUTES['mec-opt-in'].base,
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-in/mec-opt-in.component').then((m) => m.MECOptInComponent),
      },
    ],
  },
  {
    path: "mec-opt-in-laasy",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-in/mec-opt-in.component').then((m) => m.MECOptInComponent),
      },
    ],
  },
  {
    path: "mec-opt-in-wow",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-in/mec-opt-in.component').then((m) => m.MECOptInComponent),
      },
    ],
  },
  {
    path: "mec-opt-in-kapital",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-in/mec-opt-in.component').then((m) => m.MECOptInComponent),
      },
    ],
  },
  {
    path: "mec-opt-in-unifywell",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-in/mec-opt-in.component').then((m) => m.MECOptInComponent),
      },
    ],
  },
  {
    path: APP_ROUTES['mec-opt-out'].base,
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-out/mec-opt-out.component').then((m) => m.MECOptOutComponent),
      },
    ],
  },
  {
    path: "mec-opt-out-laasy",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-out/mec-opt-out.component').then((m) => m.MECOptOutComponent),
      },
    ],
  },
  {
    path: "mec-opt-out-wow",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-out/mec-opt-out.component').then((m) => m.MECOptOutComponent),
      },
    ],
  },
  {
    path: "mec-opt-out-kapital",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-out/mec-opt-out.component').then((m) => m.MECOptOutComponent),
      },
    ],
  },
  {
    path: "mec-opt-out-unifywell",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/mec-opt-out/mec-opt-out.component').then((m) => m.MECOptOutComponent),
      },
    ],
  },
  {
    path: APP_ROUTES["service-opt-out"].base,
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/service-opt-out/service-opt-out.component').then((m) => m.ServiceOptOutComponent),
      },
    ],
  },
  {
    path: APP_ROUTES["opt-me-in"].base,
    component: BlankComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import('@views/pages/opt-me-in/opt-me-in.component').then((m) => m.OptMeInComponent),
      },
    ],
  },
  {
    path: APP_ROUTES.auth.base,
    component: AuthComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: APP_ROUTES.auth.login,
        loadComponent: () =>
          import('@views/pages/login/login.component').then((m) => m.LoginPage),
      },
      {
        path: APP_ROUTES.auth.forgotPassword,
        loadComponent: () =>
          import('@views/pages/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordPage
          ),
      },
      {
        path: APP_ROUTES.auth.resetPassword,
        loadComponent: () =>
          import('@views/pages/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordPage
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.employer.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard, AdminGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.employer.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.employer.list,
        loadComponent: () =>
          import('@views/pages/employer/employer-list.component').then(
            (m) => m.EmployerListPage
          ),
      },
      {
        path: APP_ROUTES.employer.componentDetail,
        loadComponent: () =>
          import(
            '@views/pages/employer/single/components/employer-component-detail.component'
          ).then((m) => m.EmployerComponentDetailPage),
      },
      {
        path: APP_ROUTES.employer.details,
        loadComponent: () =>
          import(
            '@views/pages/employer/single/employer-details.component'
          ).then((m) => m.EmployerDetailsPage),
      },
    ],
  },
  {
    path: APP_ROUTES.employees.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.employees.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.employees.list,
        loadComponent: () =>
          import('@views/pages/employees/employees.component').then(
            (m) => m.EmployeesComponent
          ),
      },
      {
        path: APP_ROUTES.employees.details,
        loadComponent: () =>
          import(
            '@views/pages/employees/employee-details/employee-details.component'
          ).then((m) => m.EmployeeDetailsPage),
      },
    ],
  },
  {
    path: APP_ROUTES.vendor.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.vendor.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.vendor.list,
        loadComponent: () =>
          import('@views/pages/vendor/vendor.component').then(
            (m) => m.VendorComponent
          ),
      },
       {
        path: APP_ROUTES.vendor.details,
        loadComponent: () =>
          import('@views/pages/vendor/vendor-details/vendor-details.component').then(
            (m) => m.VendorDetailsComponent
          ),
      },
    ],
  },
  {
    // Agent Routes
    path: APP_ROUTES.agent.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.agent.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.agent.list,
        loadComponent: () =>
          import('@views/pages/agent/agent-list.component').then(
            (m) => m.AgentListPage
          ),
      },
      {
        path: APP_ROUTES.agent.details,
        loadComponent: () =>
          import('@views/pages/agent/single/agent-details.component').then(
            (m) => m.AgentDetailsPage
          ),
      },
    ],
  },
  {
    // Admin Routes
    path: APP_ROUTES.admin.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.admin.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.admin.list,
        loadComponent: () =>
          import('@views/pages/admin/admin-list.component').then(
            (m) => m.AdminsListPage
          ),
      },
      {
        path: APP_ROUTES.admin.details,
        loadComponent: () =>
          import('@views/pages/admin/single/admin-details.component').then(
            (m) => m.AdminDetailsPage
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.payroll.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.payroll.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.payroll.list,
        loadComponent: () =>
          import('@views/pages/actuals/actuals.component').then(
            (m) => m.ActualsComponent
          ),
      },
      {
        path: APP_ROUTES.payroll.add,
        loadComponent: () =>
          import('@views/pages/actuals/add-payroll/add-payroll.component').then(
            (m) => m.AddPayrollComponent
          ),
      },
      {
        path: APP_ROUTES.payroll.edit + '/' + APP_ROUTES.payroll.details,
        loadComponent: () =>
          import('@views/pages/actuals/add-payroll/add-payroll.component').then(
            (m) => m.AddPayrollComponent
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.census.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.census.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.census.list,
        loadComponent: () =>
          import('@views/pages/census/census.component').then(
            (m) => m.CensusComponent
          ),
      },
      {
        path: APP_ROUTES.census.add,
        loadComponent: () =>
          import('@views/pages/census/add-census/add-census.component').then(
            (m) => m.AddCensusComponent
          ),
        canDeactivate: [UnsavedChangesGuard],
      },
      {
        path: APP_ROUTES.census.edit + '/' + APP_ROUTES.census.details,
        loadComponent: () =>
          import('@views/pages/census/add-census/add-census.component').then(
            (m) => m.AddCensusComponent
          ),
        canDeactivate: [UnsavedChangesGuard],
      },
    ],
  },
  {
    path: APP_ROUTES.boarding.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.boarding.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.boarding.list,
        loadComponent: () =>
          import('@views/pages/boarding/boarding.component').then(
            (m) => m.BoardingComponent
          ),
      },
      {
        path: APP_ROUTES.boarding.add,
        loadComponent: () =>
          import(
            '@views/pages/boarding/add-boarding/add-boarding.component'
          ).then((m) => m.AddBoardingComponent),
      },
      {
        path: APP_ROUTES.boarding.edit + '/' + APP_ROUTES.boarding.details,
        loadComponent: () =>
          import(
            '@views/pages/boarding/add-boarding/add-boarding.component'
          ).then((m) => m.AddBoardingComponent),
      },
    ],
  },
  {
    path: APP_ROUTES.optout.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.optout.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.optout.add,
        loadComponent: () =>
          import('@views/pages/optout/add-optout/add-optout.component').then(
            (m) => m.AddOptoutComponent
          ),
      },
      {
        path: APP_ROUTES.optout.list,
        loadComponent: () =>
          import('@views/pages/optout/optout.component').then(
            (m) => m.BoardingComponent
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.enrollments.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.enrollments.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.enrollments.list,
        loadComponent: () =>
          import('@views/pages/enrollments/enrollments.component').then(
            (m) => m.EnrollmentsComponent
          ),
      },
      {
        path: APP_ROUTES.enrollments.add,
        loadComponent: () =>
          import('@views/pages/enrollments/add-enrollments/add-enrollments.component').then(
            (m) => m.AddEnrollmentsComponent
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.reports.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.reports.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.reports.list,
        loadComponent: () =>
          import('@views/pages/reports/reports.component').then(
            (m) => m.BoardingComponent
          ),
      },
    ],
  },

  {
    path: APP_ROUTES.settings.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@views/pages/settings/settings.component').then(
            (m) => m.SettingsComponent
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.commissions.base,
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTES.commissions.list,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTES.commissions.list,
        loadComponent: () =>
          import('@views/pages/commissions/commissions.component').then(
            (m) => m.CommissionsComponent
          ),
      },
      {
        path: APP_ROUTES.commissions.details,
        loadComponent: () =>
          import(
            '@views/pages/commissions/details/commission-details.component'
          ).then((m) => m.CommissionDetailsComponent),
      },
      {
        path: APP_ROUTES.commissions.subemployerCommissions,
        loadComponent: () =>
          import(
            '@views/pages/commissions/subemployer/subemployer-commission.component'
          ).then((m) => m.CommissionDetailsComponent),
      },
      {
        path: APP_ROUTES.commissions.employeeCommissions,
        loadComponent: () =>
          import(
            '@views/pages/commissions/employee/employee-commission.component'
          ).then((m) => m.CommissionDetailsComponent),
      },
    ],
  },
  {
    path: APP_ROUTES.fallback.default,
    redirectTo: `${APP_ROUTES.auth.base}/${APP_ROUTES.auth.login}`,
    pathMatch: 'full',
  },
  {
    path: APP_ROUTES.fallback.notFound,
    redirectTo: `${APP_ROUTES.auth.base}/${APP_ROUTES.auth.login}`,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
